module.exports = __webpack_public_path__ + "img/bl_02p_bk.20d2a7ca.png";